import { Routes } from '@angular/router';
import { DeclarationsComponent } from './declarations.component';
import { SyntheseVolumesComponent } from './pages/synthese-volumes/synthese-volumes.component';
import { ParcellaireViticoleComponent } from '../parcellaire-viticole/parcellaire-viticole.component';
import { AFFICHAGE_DR_ROUTES } from './pages/affichage-dr/affichage-dr.routes';
import { AFFICHAGE_DREV_ROUTES } from './pages/affichage-drev/affichage-drev.routes';
import { CONSULTATION_DREV_ROUTES } from './pages/consultation-drev/consultation-drev.routes';
import { HISTORIQUE_ROUTES } from './pages/historique/historique.routes';
import { PARCELLAIRES_ROUTES } from './pages/parcellaires/parcellaires.routes';
import { RECOLTES_ROUTES } from './pages/recoltes/recoltes.routes';
import { STOCKS_ROUTES } from './pages/stocks/stocks.routes';
import { ECOULEMENTS_ROUTES } from './pages/ecoulements/ecoulements.routes';
import { IMPORT_INVENTAIRE_VERGERS_ROUTES } from './pages/import-inventaire-vergers/import-inventaire-vergers.routes';

export const DECLARATIONS_ROUTES: Routes = [
    {
        path: '',
        data: {
            role: 'OPERATEUR',
            menu: {
                icon: 'file-signature',
                libelle: 'menu.declarations'
            }
        },
        children: [
            { path: '', redirectTo: 'dr', pathMatch: 'full' },
            {
                path: 'parcellaire',
                component: ParcellaireViticoleComponent,
                data: { menu: { libelle: 'Parcellaire' }, role: 'DECLARATION_INVENTAIRE_VERGER_LECTURE' }
            },
            { path: 'dr', children: AFFICHAGE_DR_ROUTES },
            { path: 'drev', children: AFFICHAGE_DREV_ROUTES },
            { path: 'consultation', children: CONSULTATION_DREV_ROUTES },
            {
                path: 'synthese',
                children: [
                    { path: '', component: SyntheseVolumesComponent, data: { menu: { libelle: 'Synthèse', icon: 'balance-scale' } } },
                    { path: ':campagne', component: SyntheseVolumesComponent, data: { title: 'Synthèse' } }
                ]
            },
            { path: 'historique', children: HISTORIQUE_ROUTES }
        ]
    }
];

export const DECLARATIONS_ANPP_ROUTES: Routes = [
    {
        path: '',
        component: DeclarationsComponent,
        data: {
            role: 'ORGANISME || DECLARATION_STOCK_LECTURE || DECLARATION_INVENTAIRE_VERGER_LECTURE || DECLARATION_RECOLTE_ECRITURE || DECLARATION_ECOULEMENT_ECRITURE',
            domaines: ['ANPP'],
            menu: {
                icon: 'file-signature',
                libelle: 'menu.declarations'
            }
        },
        children: [
            { path: '', redirectTo: 'recoltes', pathMatch: 'full' },
            { path: 'parcellaire', children: PARCELLAIRES_ROUTES },
            { path: 'recoltes', children: RECOLTES_ROUTES },
            { path: 'stocks', children: STOCKS_ROUTES },
            { path: 'ecoulements', children: ECOULEMENTS_ROUTES },
            { path: 'import-inventaire-vergers', children: IMPORT_INVENTAIRE_VERGERS_ROUTES, data: { masquageOngletsEtRecherche: true } }
        ]
    }
];
